import { useQuery } from "@tanstack/react-query";

import type { RankedProjectPipelineExtras } from "@shared/projects/pipelinePhase";
import type { Project } from "@shared/schemas/entities";
import type {
  RankedEntity,
  RankedResponse,
} from "@shared/schemas/ranking";

import { apiGet } from "@/lib/api/client";
import { queryKeys } from "@/lib/query/keys";

// W12-1: der ranked-Endpoint liefert pro Projekt zusaetzlich den naechsten
// offenen Arbeitsschritt + Lead-Annahme-Stand (Pipeline-Reiter). Partial<>
// haelt den Client robust gegen einen noch nicht deployten Server-Stand —
// fehlende Felder degradieren zu «kein Chip».
export type RankedProject = RankedEntity<
  Project & Partial<RankedProjectPipelineExtras>
>;

interface RankedProjectsResponse {
  ok: true;
  data: RankedResponse<Project & Partial<RankedProjectPipelineExtras>>;
}

interface UseRankedProjectsOptions {
  customerId?: string | undefined;
  scope?: "mine" | "all" | undefined;
  /** DATEN-4b: nur die Projektliste (Ablage «Geloescht»). */
  mitGeloeschten?: boolean | undefined;
}

export function useRankedProjects(options: UseRankedProjectsOptions = {}) {
  const { customerId, scope = "all", mitGeloeschten = false } = options;
  return useQuery({
    queryKey: [...queryKeys.projects.ranked({ customerId, scope }), mitGeloeschten ? "geloescht" : "ohne"],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (customerId) params.set("customerId", customerId);
      if (scope !== "all") params.set("scope", scope);
      if (mitGeloeschten) params.set("geloescht", "1");
      const qs = params.toString();
      const path = qs
        ? `/api/projects/ranked?${qs}`
        : "/api/projects/ranked";
      const res = await apiGet<RankedProjectsResponse>(path);
      return res.data;
    },
  });
}
